import validate from "/app/node_modules/.pnpm/nuxt@4.3.1_@parcel+watcher@2.5.6_@types+node@24.10.7_@vue+compiler-sfc@3.5.13_cac@6.7.1_b9b3c333d7db46a7ef4be30188054340/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@4.3.1_@parcel+watcher@2.5.6_@types+node@24.10.7_@vue+compiler-sfc@3.5.13_cac@6.7.1_b9b3c333d7db46a7ef4be30188054340/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "authorisation-role-based": () => import("/app/apps/dashboard/src/middleware/authorisation-role-based.ts"),
  "block-parent-child-access": () => import("/app/apps/dashboard/src/middleware/block-parent-child-access.ts"),
  "check-add-material": () => import("/app/apps/dashboard/src/middleware/check-add-material.ts"),
  "load-child-details": () => import("/app/apps/dashboard/src/middleware/load-child-details.ts"),
  "redirect-dashboard": () => import("/app/apps/dashboard/src/middleware/redirect-dashboard.ts"),
  "start-teaching": () => import("/app/apps/dashboard/src/middleware/start-teaching.ts")
}